import { endPoints, ETags } from 'src/enums';
import { emptySplitApi } from './api';

export const billingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBilling: builder.query<{ balance: number }, string>({
      query: (id) => `${endPoints.clients}/${id}/billing`,
      providesTags: [ETags.Billing],
    }),
    connectBilling: builder.query<{ url: string }, string>({
      query: (id) => `${endPoints.clients}/${id}/billing/connect`,
      providesTags: [ETags.ClientDetails],
    }),
    upBalance: builder.query<{ url: string }, string>({
      query: (id) => `${endPoints.clients}/${id}/billing/payment`,
      providesTags: [ETags.Billing],
    }),
  }),
});

export const { useLazyConnectBillingQuery, useLazyUpBalanceQuery, useGetBillingQuery } = billingApi;
